<script setup lang="ts">
import USwitch from '~/components/markup/ui/USwitch.vue'

defineProps({
  filterCode: {
    type: String,
    required: true,
  },
})

const filters = useCatalogFilter()
</script>

<template>
  <div class="filters__switcher">
    <USwitch
      :model-value="filters.isEnabledRuValues(filterCode)"
      @update:model-value="filters.toggleRuValues(filterCode)"
    />
    <div class="filters__switcher-text">Показывать параметры по&nbsp;российской системе</div>
  </div>
</template>
